// @ts-nocheck



import React, { Component } from 'react';
import Button from 'antd/lib/button';
import notification from 'antd/lib/notification';
import qs from 'query-string';
import { Link } from '../../../lib/routerAdapter';
import { navigate } from '../../../lib/routerAdapter';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';







import { Section } from './../../../components/layout';
import { Popconfirm, Table, Icon, ButtonsRow } from './../../../components/ui';
import { notificationLoading } from './../../../components/Notifications';
import Header from './../../../components/layout/Header';
import {
  getListInitialState,
  setQueryParams,
  convertVehicleToString,
  formatDateTimeToString } from
'./../../../lib/helpers';
import { inspectionGibddApi } from './../../../lib/api';
import { withUserAccess } from './../../withUserAccess';


import { setFilter } from '../../../ducks/persistFilters';


import { canHandleService, ACT_COLUMNS } from '../lib';

import InspectionGibddFilter from './Filter';













export const COLUMNS = [
{
  title: 'Марка',
  sorter: true,
  dataIndex: 'vehicle',
  render: (vehicle) => convertVehicleToString(vehicle)
},
{
  title: 'Дата обслуживания',
  dataIndex: 'maintenanceDate',
  width: '150px',
  render: (value) => formatDateTimeToString(value, 'DD.MM.YYYY')
},
{
  title: 'Следующая дата обслуживания',
  dataIndex: 'nextActDate',
  width: '150px',
  render: (value) => formatDateTimeToString(value, 'DD.MM.YYYY')
},
{
  title: 'Сумма оплаты в руб. без НДС',
  dataIndex: 'paymentAmount'
}];


export class List extends Component {
  static defaultProps = {
    location: {}
  };
  state = {
    ...getListInitialState(),
    filterPath: window.location.pathname
  };
  columns = [...COLUMNS, ...ACT_COLUMNS];

  async componentDidMount() {
    const { page, ...filter } = qs.parse(window.location.search);
    if (!isEmpty(filter)) {
      await this.setPersistFilter(filter);
    }
    if (this.canAdd()) {
      this.columns.push({
        stopPropagation: true,
        width: 20,
        dataIndex: 'id',
        render: (id) =>
        <Popconfirm
          title="Вы уверены, что хотите удалить запись?"
          onConfirm={async () => this.deleteInspectionGibdd(id)}>

            <Icon type="x" />
          </Popconfirm>

      });
    }
    await this.fetchInspectionGibddList(page);
  }

  deleteInspectionGibdd = async (id) => {
    try {
      notificationLoading({
        message: 'Удаление...',
        key: 'deleting'
      });
      await inspectionGibddApi.deleteInspectionGibdd(id);
      await this.fetchInspectionGibddList(this.state.page);
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('deleting');
    }
  };

  fetchInspectionGibddList = async (
  page = 1,
  params = {}) =>
  {
    const { filterPath } = this.state;
    const filter = this.props.persistFilters[filterPath] || {};
    try {
      this.setState({ loading: true });
      const { data, totalCount } =
      await inspectionGibddApi.fetchInspectionsGibdd({
        ...filter,
        page,
        ...params
      });
      setQueryParams({ page });
      this.setState({ data, totalCount, page });
    } catch (err) {
      notification.error({
        message: 'Ошибка',
        description: err.message
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleRowClick = (id) =>
  navigate(`/services/inspections-gibdd/${id}`);

  canAdd = () => canHandleService(this.props.userAccess);

  setPersistFilter = async (values) => {
    const { filterPath } = this.state;
    await this.props.setFilter({
      path: filterPath,
      values
    });
  };

  applyFilter = async (filter = {}) => {
    await this.setPersistFilter(filter);
    await this.fetchInspectionGibddList();
  };

  cleanFilter = this.applyFilter;

  handlePrint = async () => {
    try {
      const filter = this.props.persistFilters[this.state.filterPath];
      notificationLoading({
        message: 'Загрузка файла отчета...',
        key: 'print'
      });
      await inspectionGibddApi.printReport(filter);
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('print');
    }
  };

  render() {
    const { location } = this.props;
    const { data, totalCount, pageSize, page, loading, filterPath } =
    this.state;
    const filter = this.props.persistFilters[filterPath];
    return (
      <>
        <Header
          left={<h1>Технические осмотры ГИБДД</h1>}
          right={
          <ButtonsRow>
              <Button onClick={this.handlePrint}>Печать</Button>
              {this.canAdd() &&
            <Link to="/services/inspections-gibdd/new">
                  <Button type="primary" data-cy="add">
                    Создать
                  </Button>
                </Link>
            }
            </ButtonsRow>
          } />

        <Section>
          <InspectionGibddFilter
            filter={filter}
            applyFilter={this.applyFilter}
            cleanFilter={this.cleanFilter} />

          <Table
            onRow={(record) => ({
              onClick: () => this.handleRowClick(record.id)
            })}
            fetch={this.fetchInspectionGibddList}
            pagination={{
              page,
              pageSize,
              totalCount,
              location
            }}
            loading={loading}
            columns={this.columns}
            data={data.map((item) => ({
              ...item,
              key: item.id
            }))} />

        </Section>
      </>);

  }
}

export default connect(
  (state) => ({
    persistFilters: state.persistFilters
  }),
  {
    setFilter
  }
)(withUserAccess(List));
